import { render } from "./CatMonedaForm.vue?vue&type=template&id=1dafe65b&scoped=true"
import script from "./CatMonedaForm.vue?vue&type=script&lang=js"
export * from "./CatMonedaForm.vue?vue&type=script&lang=js"

import "./CatMonedaForm.vue?vue&type=style&index=0&id=1dafe65b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dafe65b"]])

export default __exports__